/**
 * BUSINESS PHONE API — CRUD dei phone di un Business.
 *
 * Contratto backend (rest-openapi.yaml, BusinessesResourceImpl):
 *   POST   /business/{businessId}/phone               PhoneInput -> Phone
 *   PATCH  /business/{businessId}/phone/{phoneId}     PhoneInput -> Phone
 *   DELETE /business/{businessId}/phone/{phoneId}                -> 200
 *
 * Speculare a personPhoneApi.ts. Il thunk polimorfico phoneThunks
 * instrada in base a `className`: 'Business' -> questo file.
 */

import { httpClient } from '../../api/httpClient';
import type { Phone } from '../phone/phoneTypes';

interface PhoneInput {
  number: string;
  primary: boolean;
  listTypeId?: number;
}

const NESTED = (businessId: number) => `/business/${businessId}/phone`;

export const businessPhoneApi = {
  create: (businessId: number, payload: PhoneInput): Promise<Phone> =>
    httpClient.post<Phone>(NESTED(businessId), payload).then((r) => r.data),

  update: (
    businessId: number,
    phoneId: number,
    payload: PhoneInput
  ): Promise<Phone> =>
    httpClient
      .patch<Phone>(`${NESTED(businessId)}/${phoneId}`, payload)
      .then((r) => r.data),

  remove: (businessId: number, phoneId: number): Promise<void> =>
    httpClient.delete(`${NESTED(businessId)}/${phoneId}`).then(() => undefined),
};
